import '../src/common/AppBody/AppBody.css';
import '../src/common/UploadComponent/UploadComponent.css';
import '../src/common/FileData/FileData.css';
import '../src/common/ValidationDialog/ValidationDialog.css';
import '../src/common/PageFooter/PageFooter.css';
export { default } from '@uhg-abyss/core/next-app';

